import { render, staticRenderFns } from "./SingleDocumentwithName.vue?vue&type=template&id=5b6d0c02&scoped=true"
import script from "./SingleDocumentwithName.vue?vue&type=script&lang=js"
export * from "./SingleDocumentwithName.vue?vue&type=script&lang=js"
import style0 from "./SingleDocumentwithName.vue?vue&type=style&index=0&id=5b6d0c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d0c02",
  null
  
)

export default component.exports